// Sanitizes untrusted HTML before it is injected via dangerouslySetInnerHTML.
//
// Removes inline `style="..."` attributes (and <style>/<script> tags + inline
// event handlers). This strips the inline styles that would otherwise require
// CSP `style-src 'unsafe-inline'`, so the content renders under a strict CSP —
// and it also hardens the dangerouslySetInnerHTML sinks against script
// injection. Zero external dependencies (uses the browser DOMParser).
export const sanitizeHtml = (html) => {
  if (html == null) return "";
  const input = String(html);
  if (typeof DOMParser === "undefined") return input;
  try {
    const doc = new DOMParser().parseFromString(input, "text/html");
    doc.querySelectorAll("style, script").forEach((el) => el.remove());
    doc.querySelectorAll("[style]").forEach((el) => el.removeAttribute("style"));
    doc.querySelectorAll("*").forEach((el) => {
      Array.from(el.attributes).forEach((attr) => {
        if (/^on/i.test(attr.name)) el.removeAttribute(attr.name);
      });
    });
    return doc.body.innerHTML;
  } catch (e) {
    return input;
  }
};

export default sanitizeHtml;
